module.exports = __webpack_public_path__ + "img/mainLogo.15d121f5.svg";